module.exports = __webpack_public_path__ + "static/iphone2-5b3e6736a83656683565cdbaa57dc43d.png";